import { render } from "./BaseDropdown.vue?vue&type=template&id=4627c645&scoped=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"

import "./BaseDropdown.vue?vue&type=style&index=0&id=4627c645&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4627c645"]])

export default __exports__